<template>
  <md-card class="md-card-profile">
    <div class="md-card-avatar">
      <img class="img" :src="cardUserImage" />
    </div>

    <md-card-content>

      <h4 class="card-title">Swarm.video</h4>
      <p class="card-description">
        Simple Large-Scale Live Video Streaming with higher concurrency.

        The solution for latency on live streaming across the globe.
        We cover over 90% of the Bandwidth on Peaks
      </p>
    </md-card-content>
  </md-card>
</template>
<script>
export default {
  name: "user-card",
  props: {
    cardUserImage: {
      type: String,
      default: require("@/assets/img/faces/marc.jpg")
    }
  },
  data() {
    return {};
  }
};
</script>
<style></style>
